$(document).ready(function(){
    $("input").focus(function(){
        var placeholder = $(this).attr("placeholder");
        $(this).attr("placeholder","");
        $(this).data("placeholder", placeholder);
    });
    $("input").blur(function(){
        $(this).attr("placeholder", $(this).data("placeholder"));
    });
    $('#search-form-vue input[type="text"]').on('focus', function() {
        $('input').addClass('noRadius');
    });
    $('#search-form-vue input[type="text"]').on('blur', function() {
        $('input').removeClass('noRadius');
    });
});

